import httpService from './httpService';
import { AffiliateCodeBusiness } from './model/Affiliate.model';

async function getCurrentAffiliate() {
  return httpService
    .get('/affiliate')
    .then((res) => res.data);
}


async function getAffiliateByCode(code: string) {
  return httpService
    .get(`/affiliate/code/${code}`)
    .then((res) => res.data);
}

async function createAffiliateCode(code: string) {
  const body = {
    code
  };
  return httpService
    .post('/affiliate', body)
    .then((res) => res.data);
}

async function getReferredCommunities(communityId: number): Promise<AffiliateCodeBusiness[]> {
  return httpService
    .get(`/affiliate/${communityId}/referredCommunities`)
    .then((res) => res.data);
}

async function getAffiliateLeaderboard() {
  return httpService
    .get('/affiliate/leaderboard')
    .then((res) => res.data);
}

export {
  getCurrentAffiliate,
  getAffiliateByCode,
  createAffiliateCode,
  getReferredCommunities,
  getAffiliateLeaderboard
};